"use client";
import React from "react";
import arrow from '../../assets/icons/arrow.svg';
import eye from '../../assets/icons/eye.svg';
import background from '../../assets/howto/background.png'
import Grid from '@mui/material/Grid2';
import { Box, Typography, useTheme } from "@mui/material";

const OurVision: React.FC = () => {

    const theme = useTheme();

    return (
        <Box component="section" sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "1320px",
            margin: "0 auto",
            width: "100%",
            px: 1.5,
            gap: "32px",
            flexWrap: "wrap",
        }}>
            <Box sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: {xs:"flex-start", md: "center"},
                justifyContent: "flex-start",
                flexWrap: "wrap",
            }}>
                <Typography
                    component="span"
                    variant="subtitle8"
                    sx={{
                        color: theme.palette.darkPurple[500],
                        textTransform: "uppercase",
                    }}
                >
                    OUR
                    <Box component="span" sx={{
                        color: theme.palette.lightPurple[500]}}>
                        {" "}VISION 
                    </Box>
                </Typography>
            </Box>

            <Grid container spacing={1} sx={{
                alignItems: {xs:"flex-start", md: "center"},
                display: "flex",
                flexDirection: {xs:"column", sm: "row", md: "row" },
                gap: "6px",
                alignSelf: "stretch",
            }}>
                <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{
                    alignItems: "flex-start",
                    display: "flex",
                    gap: {md: "30px", xs: "64px"},
                    flex: "1 0 0",
                    alignSelf: "stretch",
                    padding: "20px",
                    borderRadius: "12px",
                    position: "relative",
                    backgroundColor: theme.palette.darkPurple[500],
                    flexDirection: "column",
                }}>
                    <Box
                        component="img"
                        src={background}
                        alt="Background"
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "12px",
                            inset: 0,
                            position: "absolute",
                            display: "flex",
                        }}
                    />
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: "64px",
                        zIndex: 1,
                    }}>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "10px",
                            alignSelf: "stretch",
                            maxWidth: {md: "406px", xs: "100%"},
                        }}>
                            <Typography component="span" variant={"subtitle11"} sx={{
                                color: theme.palette.beige[100],
                                textTransform: "uppercase",
                            }}>
                                We envision a world where financial services are accessible, transparent, 
                                and tailored to modern needs
                            </Typography>
                        </Box>
                        <Box sx={{
                        display: "flex",
                        width: {md: "80px", xs: "60px"},
                        height: {md: "80px", xs: "60px"},
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                        borderRadius: "12px",
                        position: "relative",
                        flexDirection: "column",
                        backgroundColor: theme.palette.lime[100],
                        padding: "16px",
                    }}>
                        <Box component="img" src={eye} alt="Sparkle" sx={{
                             width: {xs: "36px", md: "48px"},
                             height: {xs: "36px", md: "48px"},
                            objectFit: "cover",
                            borderRadius: "12px",
                        }} />
                    </Box>
                    </Box>

                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{
                    alignItems: "flex-start",
                    display: "flex",
                    gap: {md: "30px", xs: "64px"},
                    flex: "1 0 0",
                    alignSelf: "stretch",
                    padding: "20px",
                    borderRadius: "12px",
                    position: "relative",
                    backgroundColor: "gray.200",
                    flexDirection: "column",
                }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: "64px",
                    }}>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "10px",
                            alignSelf: "stretch",
                            maxWidth: {md: "450px", xs: "100%"},
                        }}>
                            <Typography component="span" variant={"subtitle11"} sx={{
                                color: theme.palette.darkPurple[500],
                                textTransform: "uppercase",
                            }}>
                                Our goal is to provide a secure, intuitive platform that makes managing payments, transfers, and currency exchanges effortless
                            </Typography>
                        </Box>
                        <Box sx={{
                        display: "flex",
                        width: {md: "80px", xs: "60px"},
                        height: {md: "80px", xs: "60px"},
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                        borderRadius: "12px",
                        position: "relative",
                        flexDirection: "column",
                        backgroundColor: theme.palette.lightPurple[400],
                        padding: "16px",
                    }}>
                        <Box component="img" src={arrow} alt="Sparkle" sx={{
                             width: {xs: "36px", md: "48px"},
                             height: {xs: "36px", md: "48px"},
                            objectFit: "cover",
                            borderRadius: "12px",
                        }} />
                    </Box>
                    </Box>

                </Grid>
            </Grid>
        </Box>
    );
};

export default OurVision;
